import React from 'react'
import ReactDOM from 'react-dom/client'

import './index.css'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-balham.css'
import 'ag-grid-community/styles/ag-theme-quartz.css'

import { initFirebase } from 'constants/fireabaseConfig'

import { ThemeProvider } from '@mui/material'
import App from 'App'
import { AuthProvider } from 'AuthProvider'
import { ModuleRegistry, AllCommunityModule, provideGlobalGridOptions } from 'ag-grid-community'
import { AllEnterpriseModule, ServerSideRowModelModule, TreeDataModule } from 'ag-grid-enterprise'
import { theme } from 'style'

ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule, ServerSideRowModelModule, TreeDataModule,])

provideGlobalGridOptions({
  theme: "legacy",
  columnMenu: 'legacy'
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

initFirebase().then(() => {
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </AuthProvider>
    </React.StrictMode>
  )
})
